module.exports = __webpack_public_path__ + "img/exam_jan_2025_bz7ptcfb.9f58343c.jpg";